import { getLocalizationById } from '@context/useMyRouting/helpers';
import getLocalizationByArgs from '@helpers/getLocalizationByArgs';
import { ServiceField, ServiceFieldType } from '@onlog-public/additional-services-types';
import {
  SelectOption,
  optionsGeneratorProcessor,
} from '@pages/AdditionalServices/containers/services/optionsGenerator/types';
import { EcoFeeProductsLoaderResponse } from '@services/requests/searchLoaders/ecoFeeLoader/EcoFeeProductsLoaderQuery';
import i18next from 'i18next';

import { OptionsCache } from '../optionsLoader/types';

/**
 * EcoFeeProductProcessor реализует процессор генерации опций для товаров экосбора
 */
export class EcoFeeProductProcessor implements optionsGeneratorProcessor {
  /**
   * getType возвращает тип поля, для которого реализован процессор
   */
  getType(): ServiceFieldType {
    return 'product';
  }

  /**
   * getOptions генерирует опции для селектора поля дополнительных услуг
   * @param field
   * @param langID
   * @param cache
   */
  getOptions(field: ServiceField, langID: string, cache: OptionsCache<any>): SelectOption[] {
    const langCode = getLocalizationById(langID).countryCode;
    const t = i18next.getFixedT(langCode);

    const optionID = [...field.handbook_limitations];
    if (optionID.length === 0) {
      optionID.push(String(field.value));
    }

    const productsData: EcoFeeProductsLoaderResponse['items'] = optionID
      .map((id) => cache.cache[id])
      .filter((v) => !!v);

    return productsData.map((d) => ({
      value: parseInt(d.id),
      label: `${t('Common:Product')}: ${getLocalizationByArgs(
        langID,
        d.default_name ?? '',
        d.localized_names_data
      )}, ${`[${t('Common:TNVED')}: ${d.tnved_code} / ${t('Common:OKVED')}: ${d.okved_code}]`}`,
      description: `${t('Common:Group')} №${d.group.number_group} "${d.group.name ?? ''}" / ${t(
        'Common:RateValue'
      )}: ${d.group.rate_value ?? ''}  /  ${t('Common:Normative')}: ${
        d.group.normative_value ?? ''
      }  /  ${t('Common:Coefficient')}: ${d.group.coefficient ?? ''}`,
      origin: d,
    }));
  }
}
